var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75625 2.625C1.75625 2.43714 1.8142 2.25697 1.91734 2.12413C2.02049 1.99129 2.16038 1.91667 2.30625 1.91667H10.0063C10.1521 1.91667 10.292 1.99129 10.3952 2.12413C10.4983 2.25697 10.5563 2.43714 10.5563 2.625V15.375C10.5563 15.5629 10.4983 15.743 10.3952 15.8759C10.292 16.0087 10.1521 16.0833 10.0063 16.0833H2.30625C2.16038 16.0833 2.02049 16.0087 1.91734 15.8759C1.8142 15.743 1.75625 15.5629 1.75625 15.375V2.625ZM2.30625 0.5C1.86864 0.5 1.44896 0.723883 1.13952 1.1224C0.830089 1.52091 0.65625 2.06141 0.65625 2.625V15.375C0.65625 15.9386 0.830089 16.4791 1.13952 16.8776C1.44896 17.2761 1.86864 17.5 2.30625 17.5H10.0063C10.4439 17.5 10.8635 17.2761 11.173 16.8776C11.4824 16.4791 11.6562 15.9386 11.6562 15.375V2.625C11.6562 2.06141 11.4824 1.52091 11.173 1.1224C10.8635 0.723883 10.4439 0.5 10.0063 0.5H2.30625ZM4.50625 14.6667H7.80625V13.25H4.50625V14.6667Z",
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobile);
export default __webpack_public_path__ + "static/media/icon-mobile.092827af97edc4b80075f4ce19da7292.svg";
export { ForwardRef as ReactComponent };